import { defineComponent as _defineComponent } from 'vue'
import { useSurfaceStore } from '@@/pinia/surface'
import { useWindowSizeStore } from '@@/pinia/window_size'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BeethovenAttachmentCaption',
  props: {
    usageContext: null,
    attachmentCaption: { default: '' },
    darkThemeType: { default: 'browser' },
    isDark: { type: Boolean, default: false }
  },
  emits: ["click", "edit-start"],
  setup(__props: any) {

const props = __props as { usageContext: 'postModal' | 'postView', attachmentCaption: string, darkThemeType: 'browser' | 'custom', isDark: boolean };





const { isPhone } = storeToRefs(useWindowSizeStore())
const { isStream, isWhiteboard } = storeToRefs(useSurfaceStore())

const xBigCaption = computed(() => {
  if (props.usageContext === 'postView') {
    return isStream.value
  } else if (props.usageContext === 'postModal') {
    return !isPhone.value
  }
  return false
})

return { __sfc: true,props, isPhone, isStream, isWhiteboard, xBigCaption }
}

})